var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "4781840_+_add_circle_create_expand_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rect\\xE1ngulo 289",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.962 16.001l5.28-5.28A.879.879 0 0020 9.478l-5.28 5.28-5.28-5.28a.879.879 0 00-1.242 1.243l5.28 5.28-5.28 5.284a.878.878 0 101.242 1.238l5.28-5.28 5.28 5.28a.878.878 0 001.24-1.238zm0 0",
    fill: "#223983"
  })));
}

export default SvgCloseinline;